export enum Role {
    Admin = "Admin",
    Contact = "Contact",
    Employee = "Employee",
    Flexworker = "Flexworker",
    JobSeeker = "JobSeeker"

}
